import permissions, { RESOURCE_ADMINISTRACION_PG } from '@/auth/permissions/modules/administracionPg'
import {
    ROUTE_AREA,
    ROUTE_DEPARTAMENTO,
    ROUTE_EDIFICIO,
    ROUTE_ESTABLECIMIENTO,
    ROUTE_MACRODEPARTAMENTO,
    ROUTE_PROCESO,
    ROUTE_UNIDAD_NEGOCIO,
} from '@/router/routes/administracion-pg/nombres'
import { defineMenu } from '@/utils/menu'

const { mantenimiento } = permissions

export default defineMenu([
    {
        title: 'administracion.mantenimiento.unidad_negocio.titulo',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: mantenimiento.unidadNegocio,
        route: ROUTE_UNIDAD_NEGOCIO,
    },
    {
        title: 'administracion.mantenimiento.establecimiento.titulo',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: mantenimiento.establecimiento,
        route: ROUTE_ESTABLECIMIENTO,
    },
    {
        title: 'administracion.mantenimiento.macro_departamento.titulo',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: mantenimiento.macrodepartamento,
        route: ROUTE_MACRODEPARTAMENTO,
    },
    {
        title: 'administracion.mantenimiento.departamento.titulo',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: mantenimiento.departamento,
        route: ROUTE_DEPARTAMENTO,
    },
    {
        title: 'global.labels.edificio',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: mantenimiento.edificio,
        route: ROUTE_EDIFICIO,
    },
    {
        title: 'global.labels.proceso',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: mantenimiento.proceso,
        route: ROUTE_PROCESO,
    },
    {
        title: 'global.labels.area',
        resource: RESOURCE_ADMINISTRACION_PG,
        action: mantenimiento.area,
        route: ROUTE_AREA,
    },
])
